<template>
    <div
        :class="[
            'video-block',
            'block',
            layout.layout
        ]"
    >
        <div class="sizer">
            <div class="holder">
                <transition>
                    <iframe
                        width="100%"
                        height="100%"
                        :src="url"
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
                        v-if="playable || !layout.poster"
                    ></iframe>
                    <div class="cover" @click="playable = true" v-else>
                        <Parallax class="poster" :power="0.1">
                            <div
                                class="poster scale"
                                :style="{
                                    backgroundImage: `url(${layout.poster})`
                                }"
                            />
                        </Parallax>
                        <div class="play">
                            <svg
                            	 viewBox="0 0 126.2 126.2"
                                >
                            	<polygon class="st0" points="54.2,63.1 54.2,50.1 65.4,56.6 76.7,63.1 65.4,69.6 54.2,76.1 	"/>
                            	<circle class="st1" cx="63.1" cy="63.1" r="60.6"/>
                            	<polygon class="st0 red" points="54.2,63.1 54.2,50.1 65.4,56.6 76.7,63.1 65.4,69.6 54.2,76.1 	"/>
                            	<circle class="st1 red" cx="63.1" cy="63.1" r="60.6"/>
                            </svg>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <div
            v-if="layout.layout === 'alignright'"
            class="caption"
            v-html="layout.caption"
        />
    </div>
</template>

<script>
import Parallax from '@/components/animation/Parallax'
export default {
    components: {
        Parallax
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    data() {
        return {
            playable: false
        }
    },
    computed: {
        url() {
            let url = this.layout.url
            if(this.layout.poster) {
                url += '?autoplay=1'
            }
            return url
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.video-block
  margin-bottom: 10%;
  &:v-deep + .highlight-block
    margin-top: 14%

.block
    position: relative
    @include media-breakpoint-down($lg)
        margin-left: 0
        margin-right: 0
    &.alignright
        margin-right: 0
        margin-left: 25.83334%
        @include media-breakpoint-down($lg)
            margin-left: 0
            margin-right: 0

.sizer
    height: 0
    padding-bottom: 56.25%
    // padding-bottom: 49%
    position: relative
    overflow: hidden
    @include media-breakpoint-down($lg)
        padding-bottom: 56.25%
    .holder,
    .cover,
    .poster
        position: absolute
        left: 0
        top: 0
        bottom: 0
        right: 0
    .cover
        cursor: pointer
        transition: opacity .625s .3s
        &.v-leave-to
            opacity: 0
        &:hover
            .st0.red
                opacity: 1
            .st1
                stroke-dashoffset: 381
            .st1.red
                stroke-dashoffset: 0

    .poster
        background-color: black
        background-position: 50% 50%
        background-repeat: no-repeat
        background-size: cover
        .scale
            transform: scale(1.1)
.play
    width: 126px
    height: 126px
    position: absolute
    left: 50%
    top: 50%
    margin-left: -63px
    margin-top: -63px
    svg
        width: 100%
        height: 100%
.st0
    fill: #FFFFFE
    &.red
        fill: #ff2b2a
        opacity: 0
        transition: opacity .625s
.st1
    fill: none
    stroke: #FFFFFE
    stroke-width: 5
    stroke-miterlimit: 10
    transition: stroke-dashoffset .625s
    stroke-dasharray: 381
    &.red
        stroke: #ff2b2a
        stroke-dasharray: 381
        stroke-dashoffset: -381
.caption
    font-size: 160px
    color: #ff2b2a
    margin: 0
    line-height: 0.89375
    font-weight: 500
    letter-spacing: -0.03125em
    position: absolute
    right: 100%
    transform: translateX(50%) rotate(-90deg)
    margin-right: .625em
    top: 100%
    margin-top: .625em
    @include media-breakpoint-down($hd)
        opacity: 0.05
    @include media-breakpoint-down($lg)
        display: none
</style>
